import { useRuntime } from '../../shell';
export class TrackingService {
    track(data) {
        console.log('[tracking] Tracking the following data: ', data);
    }
}
export const TrackingServiceKey = 'tracking';
export function useTrackingService() {
    const runtime = useRuntime();
    return runtime.getService(TrackingServiceKey);
}
